import ResidentGallery from './ResidentGallery';

export default ResidentGallery;